export const TOKEN_KEY = "@apoio:token";

export const setToken = ( token = "" ) => sessionStorage.setItem( TOKEN_KEY, token );

export const removeToken = () => sessionStorage.removeItem( TOKEN_KEY );

// export const verificaToken = async (token, armazenaUsuario = false) => {
//   try {
//     axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
//     const url = `${URLDEFAULT}api/security/getcurrentuser`;
//     const resposta = await axios.get(url);

//     if (armazenaUsuario) {
//       await AsyncStorage.setItem(
//         CURRENTUSER_KEY,
//         JSON.stringify(resposta.data)
//       );
//     }
//     return resposta.status == 200 ? resposta.data : false;
//   } catch (error) {
//     console.log("Erro verficar Token: ", error);
//     return false;
//   }
// };

export const getToken = () => sessionStorage.getItem( TOKEN_KEY );
